import { UserDetailsInterface, userDataInterface } from "../../models";
import { UserActionTypes } from "./user.types";
import { dataConstants } from "../../constants/data-constants";
import jwtDecode from "jwt-decode";
import { axiosClient } from "../../utils/axios-config";
import {
  fetchBranchCropVarieties,
  fetchPrivacyPolicy,
  fetchTermsCondition,
  setActiveTab,
  setErrorMsg,
  setLoading,
  setSuccessMsg,
} from "../common/common.actions";
import GlobalLogoutClient from "../../services/forced-logout-services";
import triggerAnalyticsClient from "../../services/analytics-services";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { decrypt, encrypt } from "../../utils/utility-functions";

//************************ Synchronous Actions **************************//
export const setUserLoggedInStatus = (status: boolean): any => {
  return {
    type: UserActionTypes.SET_LOGGED_IN_STATUS,
    payload: status,
  };
};
export const setAuthData = (userData: any): any => {
  return {
    type: UserActionTypes.SET_AUTH_DATA,
    payload: userData,
  };
};
export const setIpAdress = (ipAddress: any): any => {
  return {
    type: UserActionTypes.SET_IP_ADDRESS,
    payload: ipAddress,
  };
};
export const setIdleModal = (userData: boolean): any => {
  return {
    type: UserActionTypes.SET_IDLE_MODAL,
    payload: userData,
  };
};
export const setProfileDetails = (userDetails: UserDetailsInterface) => {
  return {
    type: UserActionTypes.SET_USER_DETAILS,
    payload: userDetails,
  };
};
export const resetUserState = (): any => {
  return {
    type: UserActionTypes.RESET_STATE,
  };
};
export const setUserData = (userData: userDataInterface) => {
  return {
    type: UserActionTypes.SET_USER_DATA,
    payload: userData,
  };
};
export const setFirstTimeLogin = (userData: boolean) => {
  return {
    type: UserActionTypes.SET_FIRST_LOGIN,
    payload: userData,
  };
};
export const setTour = (userData: boolean) => {
  return {
    type: UserActionTypes.SET_TOUR,
    payload: userData,
  };
};

//************************ Asynchronous Actions **************************//
//************************ Auth Actions *********************************//
export const registration = (body: any): any => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.postRegisterUrl, body)
        .then((response) => {
          dispatch(setLoading(false));
          dispatch(
            setSuccessMsg("Your application has been submitted successfully.")
          );
          return resolve(true);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(
            setErrorMsg(
              error?.response?.data?.message ||
              "Something went wrong, Please try again later."
            )
          );
          return resolve(false);
        });
    });
  };
};

export const generateOtp = (body: any): any => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.generateOtp, body)
        .then((response) => {
          dispatch(setSuccessMsg(response.data.message));
          dispatch(setLoading(false));
          return resolve(true);
        })
        .catch((error) => {
          dispatch(
            setErrorMsg(
              error?.response?.data?.message ||
              error?.response?.statusText ||
              "Something went wrong, Please try again later."
            )
          );
          dispatch(setLoading(false));
          return resolve(false);
        });
    });
  };
};
export const verifyOtp = (body: any): any => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.verifyOtp, body)
        .then((response) => {
          dispatch(setSuccessMsg(response.data.message));
          dispatch(setLoading(false));
          return resolve(response.data);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(
            setErrorMsg(
              error?.response?.data?.message ||
              "Something went wrong, Please try again later."
            )
          );
          return resolve(error?.response?.data?.status);
        });
    });
  };
};

export const logIn = ({
  username,
  password,
  supplier = true,
  force_login = false,
}: {
  username: string;
  password: string;
  supplier?: boolean;
  force_login?: boolean;
}): any => {
  return async (dispatch: any, getState: any) => {
    dispatch(setLoading(true));
    try {
      let ip_address;
      const hashUsername = encrypt(username);
      const hashPassword = encrypt(password);
      await axios
        .get("https://api.ipify.org?format=json")
        .then((response) => {
          ip_address = encrypt(response.data.ip);
        })
        .catch((error) => {
          console.error("Error fetching IP address", error);
        });
      const response: any = await axiosClient.post(dataConstants.loginUrl, {
        username: hashUsername,
        password: hashPassword,
        supplier,
        ip_address,
        force_login,
      });
      const decodedId: userDataInterface = jwtDecode(
        response.data.data.id_token
      );
      dispatch(setAuthData(response.data.data));
      dispatch(setIpAdress(ip_address));
      dispatch(setUserData(decodedId));
      await dispatch(fetchUserDetails(decodedId.user_id, false));
      const value = secureLocalStorage.getItem("deviceToken");
      const dataToSend = {
        user_id: decodedId.user_id,
        device_id: "web",
        device_token: value,
      };
      await dispatch(sendUserDeviceToken(dataToSend));
      await dispatchLoginActions(dispatch, getState);
      return true;
    } catch (error: any) {
      dispatch(setLoading(false));
      if (error.response.data?.data?.hasOwnProperty("force_login_required")) {
        return error?.response?.data?.message
      }
      error?.response?.data?.message &&
        dispatch(
          setErrorMsg(
            error.response.data.message || `${username} could not login!`
          )
        );
      return false;
    }
  };
};

const dispatchLoginActions = async (dispatch: any, getState: any) => {
  await dispatch(fetchBranchCropVarieties());
  dispatch(setActiveTab(0));
  // dispatch(fetchTermsCondition(false));
  // dispatch(fetchPrivacyPolicy(false));
  triggerAnalyticsClient.emitEvent(
    "TN-Login",
    { module: "Dashboard", activity: "Logged In" },
    { User: getState().user.userDetails.user_name },
    getState().user.userDetails.user_name
  );
  dispatch(setUserLoggedInStatus(true));
  dispatch(setLoading(false));
  dispatch(setSuccessMsg(`Welcome ${getState().user.userData.name}`));
};

export const resetPassword = (
  values: {
    user_name: string;
    old_password: string;
    new_password: string;
    confirm_password?: string;
  },
  isResetPassword: boolean
): any => {
  return (dispatch: any, getState: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      values.user_name = encrypt(values.user_name);
      values.old_password = encrypt(values.old_password);
      values.new_password = encrypt(values.new_password);
      values.confirm_password = encrypt(values.confirm_password);
      axiosClient
        .put(isResetPassword ? dataConstants.resetPasswordUrl : dataConstants.changePasswordUrl, values)
        .then((response) => {
          dispatch(setLoading(false));
          getState().user.userData.is_first_time_login &&
            dispatch(setFirstTimeLogin(false));
          dispatch(setSuccessMsg("Password reset successfully!"));
          resolve(true);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(
            setErrorMsg(
              isResetPassword &&
                error?.response?.data?.msg &&
                error?.response?.data?.msg.includes("Incorrect old password")
                ? "Incorrect Reset Code."
                : error?.response?.data?.msg ||
                "Something went wrong, Please try again later."
            )
          );
          resolve(false);
        });
    });
  };
};

export const forgotPassword = ({
  user_name,
  supplier = true,
}: {
  user_name: string;
  supplier?: boolean;
}): any => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .put(dataConstants.forgotPasswordUrl, { user_name, supplier })
        .then((response) => {
          dispatch(setLoading(false));
          dispatch(setSuccessMsg(response.data.message));
          return resolve(true);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(
            setErrorMsg(
              error?.response?.data?.message ||
              "Something went wrong, Please try again later."
            )
          );
          return resolve(false);
        });
    });
  };
};

export const logOut = (): any => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    axiosClient
      .post(dataConstants.logoutUrl)
      .then(() => {
        GlobalLogoutClient.Logout();
        dispatch(setLoading(false));
        dispatch(setSuccessMsg("Logged out successfully!"));
      })
      .catch(() => {
        GlobalLogoutClient.Logout();
        dispatch(setLoading(false));
        // dispatch(setErrorMsg("Could not logout."));
      });
  };
};

//************************ User Actions *********************************//
export const fetchUserDetails = (
  user_id?: number,
  msg: boolean = true
): any => {
  return (dispatch: any, getState: any) => {
    dispatch(setLoading(true));
    axiosClient
      .post(dataConstants.getUserDetailsUrl, {
        user_id: user_id || getState().user.userDetails.user_id,
      })
      .then((response: any) => {
        dispatch(setProfileDetails({ ...response.data.data[0], profile_photo: response.data.data[0].profile_photo && decrypt(response.data.data[0].profile_photo) }));
        triggerAnalyticsClient.setAmplitudeUser(response.data.data[0]);
        dispatch(setLoading(false));
        msg && dispatch(setSuccessMsg("Profile Details fetched successfully!"));
      })
      .catch((error) => {
        dispatch(setLoading(false));
        dispatch(setErrorMsg("Profile Details could not be fetched."));
      });
  };
};

export const setUserDetails = (data: any): any => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    data.profile_photo ?
      await axiosClient
        .post(dataConstants.postPhotoSasUrl, { file_type: data.profile_photo.type === "image/png" ? "png" : "jpeg" })
        .then(async (response) => {
          const blobName = response.data.data.blob_name
          response.data.data.upload_url &&
            axios
              .put(decrypt(response.data.data.upload_url), data.profile_photo.originFileObj, {
                headers: {
                  "Content-Type": data.profile_photo.type,
                  "x-ms-blob-type": "BlockBlob",
                }
              })
              .then(async (response) => {
                axiosClient
                  .put(dataConstants.postUserDetailsUrl, { ...data, profile_photo: blobName })
                  .then(async (response) => {
                    // dispatch(setProfileDetails(data));
                    await dispatch(fetchUserDetails(data.user_id, false));
                    dispatch(setLoading(false));
                    dispatch(setSuccessMsg("Profile Details updated successfully!"));
                  })
                  .catch((error) => {
                    dispatch(setLoading(false));
                    dispatch(setErrorMsg("Profile Details could not be updated!"));
                  });
              }).catch(error => console.error(error))
        }).catch(error => console.error(error))
      : axiosClient
        .put(dataConstants.postUserDetailsUrl, { ...data, profile_photo: "" })
        .then(async (response) => {
          // dispatch(setProfileDetails(data));
          await dispatch(fetchUserDetails(data.user_id, false));
          dispatch(setLoading(false));
          dispatch(setSuccessMsg("Profile Details updated successfully!"));
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(setErrorMsg("Profile Details could not be updated!"));
        });
  };
};

export const checkUserExists = (data: any): any => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.checkPANUrl, data)
        .then((response) => {
          dispatch(setLoading(false));
          if (response.data.status) {
            dispatch(
              setSuccessMsg(
                response.data.message || "Please enter valid pan number"
              )
            );
          } else {
            dispatch(
              setErrorMsg(
                response.data.message || "Please enter valid pan number"
              )
            );
          }
          return resolve(response.data.status);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          return resolve(false);
        });
    });
  };
};
export const sendUserDeviceToken = (data: any): any => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      // dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.userDevicesUrl, data)
        .then((response) => {
          // dispatch(setLoading(false));
          return resolve(true);
        })
        .catch((error) => {
          // dispatch(setLoading(false));
          return resolve(false);
        });
    });
  };
};
